import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { GridReadyEvent } from "ag-grid-community";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { AgGridActionbutton } from "src/app/shared/common/AgGridActionbutton";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { CreateDecisionPopUpComponent } from "./create-decision-pop-up/create-decision-pop-up.component";
import { ActionDialogComponent } from "../../jsignal-product/action-dialog/action-dialog.component";


interface ValidationError {
  component: string;
  field?: string;
  message: string;
}

interface ValidationResult {
  valid: boolean;
  errors: ValidationError[];
}

@Component({
    selector: "app-signal-decision",
    templateUrl: "./signal-decision.component.html",
    styleUrls: ["./signal-decision.component.scss"],
    standalone: false
})
export class SignalDecisionComponent implements OnInit {
  //Based on signalId and  StepID data must be loaded and displayed in grid
  @Input() signalId!: any;
  @Input() stepId!: number;

  @Output() saveAndNextDecision = new EventEmitter<void>();

  decisionData: any;
  components: any;
  columnDefs: any;
  defaultColDef: any;
  gridApi: any;
  getRowStyle: (params: any) => { backgroundColor: string; };

  constructor(
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private jsignalsService: JsignalService,
    private localStorageSettings: LocalStorageSettingsService,
    private fb: FormBuilder,
    private dialog: MatDialog,
  ) {
    this.components = {
      jsignalButton: JSIGNALBUTTON,
      buttonRenderer: AgGridActionbutton,
    };
  }

  ngOnInit(): void {
    this.initializeGrid();
    this.loadDecisionDataBasedOnSignalId();
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: "Decision ID",
        field: "decisionId",
        width: 180,
        ...this.jsignalsService.autoTooltip("Decision ID"),
      },
      {
        headerName: "Decision Version",
        field: "decisionVersion",
        width: 160,
        
    
        ...this.jsignalsService.autoTooltip("Decision Version"),
      },
        {
        headerName: "Is Latest Version",
        field: "isLatestVersion",
        width: 160,
        hide:true,
        ...this.jsignalsService.autoTooltip("Is Latest Version"),
      },

      {
        headerName: "Effective Date",
        field: "effectiveDate",
        width: 220,
        ...this.jsignalsService.autoTooltip("Effective Date"),
      },

      {
        headerName: "Source",
        field: "source",
        width: 200,
        ...this.jsignalsService.autoTooltip("Source"),
      },

      {
        headerName: "Decision Description",
        field: "decisionDescription",
        width: 300,
        ...this.jsignalsService.autoTooltip("Decision Description"),
      },

      {
        headerName: "Decision",
        field: "decision",
        width: 180,
        ...this.jsignalsService.autoTooltip("Decision"),
      },

      // {
      //   headerName: "Decision Outcome",
      //   field: "decisionOutcome",
      //   width: 200,
      //   ...this.jsignalsService.autoTooltip("Decision Outcome"),
      // },

      {
        headerName: "Safety Communication",
        field: "safetyCommunication",
        width: 220,
        ...this.jsignalsService.autoTooltip("Safety Communication"),
      },

      // {
      //   headerName: "Decision Rank",
      //   field: "decisionRank",
      //   width: 150,
      //   type: "numericColumn",
      //   ...this.jsignalsService.autoTooltip("Decision Rank"),
      // },
      {
        headerName: "Action",
        sortable: false,
        filter: false,
        resizable: true,
        width: 180,
        cellRenderer: "buttonRenderer",
        pinned: "right",
        lockPinned: true,
        cellRendererParams: (params: any) => ({
          edit: this.EditIcon.bind(this),
          delete: this.deleteIcon.bind(this),
          // Additional buttons based on your requirements
          action: this.takeAction.bind(this),
          // outcome: this.Outcome.bind(this),
        }),
      },
    ];

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      filter: true,
      resizable: true,
    };

    this.getRowStyle = (params: any) => {
    console.log(params);
    console.log(params.data.isLatestVersion);
    if (params.data.isLatestVersion === false) {
      return { backgroundColor: "rgb(211, 211, 211)" }; // Inline style for olderversion rows
    }
    // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
  };
  }

  EditIcon(params: any) {
    if(params.rowData.isLatestVersion === false){
      this.snackBar.open('Cannot edit older versions. Please create a new version to make changes.', 'Close', { duration: 3000 });
      return;
    }
    console.log("Edit clicked", params.rowData);
      this.dialog.open(CreateDecisionPopUpComponent, {
      maxWidth: "100vw",
      height: "95%",
      width: "90%",
      data: { mode: 'edit',formData: params.rowData },
      disableClose: true,
   
  }).afterClosed()
  .subscribe((result) => {
    if (result) {
      this.updateSignalDecisions(params.rowData.id, result); // receives latest data
    }
  });
  }

  deleteIcon(params: any) {
        if(params.rowData.isLatestVersion === false){
      this.snackBar.open('Cannot delete older versions. Please create a new version to make changes.', 'Close', { duration: 3000 });
      return;
    }
    console.log("Delete clicked", params.rowData);
    this.deleteDecision(params.rowData.id);
  }

  takeAction(params: any) {
        if(params.rowData.isLatestVersion === false){
      this.snackBar.open('Cannot take action on older versions. Please create a new version to make changes.', 'Close', { duration: 3000 });
      return;
    }
    console.log("Action clicked", params.data);
    const dialogRef = this.dialog.open(ActionDialogComponent, {
        width: '800px',
        maxWidth: '95vw',
        disableClose: false,
        panelClass: 'action-dialog-panel',
          data:  null
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            console.log("result For Action : " , result);
 
          }
        });
  }

  // Outcome(params: any) {
  //   console.log("Outcome clicked", params.data);
  // }


  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    console.log("Grid is ready, API set:", !!this.gridApi); // Debug log

    // Load data after grid is ready
    // this.loadGridData();
  }

  onRefresh() {
    console.log("Refresh button clicked");
    this.loadDecisionDataBasedOnSignalId();
  }

  onDownload() {
    // if (!this.gridApi || !this.rowData || this.rowData.length === 0) {
    //   this.snackBar.open('No data to export', 'Close', { duration: 3000 });
    //   return;
    // }

    // this.spinner.start();

    setTimeout(() => {
      this.gridApi.exportDataAsCsv({
        fileName: "Decision.csv",
      });
      // this.spinner.stop();
    }, 500);
  }

  onCreate() {
    console.log("Create button clicked");
    this.dialog.open(CreateDecisionPopUpComponent, {
      maxWidth: "100vw",
      height: "95%",
      width: "90%",
      data: { mode: 'create' },
      disableClose: true,
   
  }).afterClosed()
  .subscribe((result) => {
    if (result) {
      this.createSignalDecision(this.signalId, result); // receives latest data
    }
  });
  }

  onNext() {
    console.log("Next button clicked");
    this.saveAndNextDecision.emit();
  }

  loadDecisionDataBasedOnSignalId() {
    console.log("Loading decision data for signalId:", this.signalId, "and stepId:", this.stepId);
    this.spinner.start();

    this.jsignalsService
      .getAllSignalDecisionsBasedOnSignalId(this.signalId)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            this.decisionData = []; // Clear the grid data on error
            return;
          }
          // this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.spinner.stop();
          this.decisionData = res || []; // Update the grid data with the response

        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.spinner.stop();

          this.decisionData = []; // Clear the grid data on error
        },
      });  

  }

//   validateStep(): ValidationResult {

//   // const errors: ValidationError[] = [];

//   // if (!this.decisionData || this.decisionData.length === 0) {
//   //   errors.push({
//   //     component: 'Decision',
//   //     message: 'At least one decision required'
//   //   });
//   // }

//   // return {
//   //   valid: errors.length === 0,
//   //   errors
//   // };
// }

createSignalDecision(signalId:number, payload: any) {
  this.spinner.start();

    this.jsignalsService
      .createSignalDecisionBasedOnSignalId(signalId,payload)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.loadDecisionDataBasedOnSignalId();
            this.spinner.stop();
           
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
           this.loadDecisionDataBasedOnSignalId(); // Update the grid data with the response
          this.spinner.stop();
         

        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
           this.loadDecisionDataBasedOnSignalId(); // Clear the grid data on error
          this.spinner.stop();
         
        },
      });  

}

updateSignalDecisions(decisionId:number,payload?: any) {
  this.spinner.start();

    this.jsignalsService
      .updateSignalDecision(decisionId, payload)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.loadDecisionDataBasedOnSignalId();
            this.spinner.stop();
           
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
           this.loadDecisionDataBasedOnSignalId(); // Update the grid data with the response
          this.spinner.stop();
         

        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
           this.loadDecisionDataBasedOnSignalId(); // Clear the grid data on error
          this.spinner.stop();
         
        },
      });  
}

deleteDecision(decisionId:number) {
  this.spinner.start();

    this.jsignalsService
      .deleteSignalDecision(decisionId)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.loadDecisionDataBasedOnSignalId();
            this.spinner.stop();
           
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
           this.loadDecisionDataBasedOnSignalId(); // Update the grid data with the response
          this.spinner.stop();
         

        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
           this.loadDecisionDataBasedOnSignalId(); // Clear the grid data on error
          this.spinner.stop();
         
        },
      });  

}
}
